import type { Object } from "fabric/fabric-impl";
import { BackgroundImage, ViewportShape } from "../types/objectTypes";

export function isViewport(obj: Object): obj is ViewportShape {
  return "meaning" in obj && obj.meaning === "viewport";
}

export function isBackgroundImage(obj: Object): obj is BackgroundImage {
  return "meaning" in obj && obj.meaning === "background-image";
}
